"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.controls = void 0;

var _colors = require("./colors.theme");

var _fonts = require("./fonts.theme");

var _colors2 = require("../utils/colors");

var controls = {
  Nav: {
    backgroundColor: function backgroundColor(showBackground) {
      return showBackground ? {
        withLightBg: _colors.colors.white,
        withDarkBg: _colors.colors.brandThemeDark900
      } : 'transparent';
    },
    textColor: {
      withLightBg: _colors.colors.brandThemeDark900,
      withDarkBg: _colors.colors.white
    },
    fontStyle: _fonts.fonts.fontSystem.regular,
    fontSize: '1.075rem',
    modal: {
      padding: '4.3125rem 0 0 1.1rem',
      justifyContent: 'flex-start',
      alignItems: 'flex-start',
      textAlign: 'left',
      maxWidth: 'auto',
      fontWeight: _fonts.fonts.fontSystem.regular.default.fontWeight
    }
  },
  carousel: {
    iconColor: {
      withLightBg: _colors.colors.black,
      withDarkBg: _colors.colors.white
    }
  },
  pillSelector: {
    hoverColor: _colors.colors.actionPrimary300,
    textColor: {
      withLightBg: _colors.colors.brandThemeDark900,
      withDarkBg: _colors.colors.white
    },
    activeColor: {
      backgroundColor: _colors.colors.actionPrimary300,
      textColor: _colors.colors.white
    },
    borderColor: {
      withLightBg: _colors.colors.brandThemeDark900,
      withDarkBg: _colors.colors.white
    }
  },
  button: {
    mainColor: {
      withLightBg: _colors.colors.actionPrimary300,
      withDarkBg: _colors.colors.actionPrimary300
    },
    textColor: {
      withLightBg: _colors.colors.actionPrimary300,
      withDarkBg: _colors.colors.actionPrimary300
    },
    hoverColor: _colors.colors.actionPrimary500,
    border: {
      radius: '8px'
    },
    padding: '.7em 2em',
    minWidth: '80px',
    fontSize: '1rem'
  },
  card: {
    padding: '1rem',
    border: {
      width: '1px',
      style: 'solid',
      color: _colors.colors.brandThemeLight500,
      radius: '5px'
    },
    background: {
      color: _colors.colors.white
    }
  },
  modal: {
    padding: '1rem',
    background: {
      withLightBg: _colors.colors.white,
      withDarkBg: _colors.colors.brandThemeDark900
    },
    textColor: {
      withLightBg: _colors.colors.primaryFont,
      withDarkBg: _colors.colors.white
    },
    closeButton: {
      color: {
        withLightBg: (0, _colors2.getRGBOpacity)(_colors.colors.brandThemeDark900, 0.3),
        withDarkBg: (0, _colors2.getRGBOpacity)(_colors.colors.white, 0.1)
      },
      hoverColor: {
        withLightBg: _colors.colors.primaryFont,
        withDarkBg: _colors.colors.primaryFont
      }
    },
    zIndex: 5
  },
  listItem: {
    textColor: {
      withLightBg: _colors.colors.primaryFont,
      withDarkBg: _colors.colors.white
    },
    hoverBackgroundColor: {
      withLightBg: _colors.colors.brandThemeLight100,
      withDarkBg: _colors.colors.brandThemeDark700
    },
    selectedBackgroundColor: {
      withLightBg: _colors.colors.brandThemeLight100,
      withDarkBg: _colors.colors.brandThemeDark700
    },
    padding: '.7em 0'
  },
  list: {
    background: {
      color: {
        withLightBg: _colors.colors.white,
        withDarkBg: _colors.colors.brandThemeDark900
      }
    },
    border: {
      topLeftRadius: '0px',
      topRightRadius: '0px',
      bottomLeftRadius: '10px',
      bottomRightRadius: '10px',
      width: '1px',
      style: 'solid',
      top: '0',
      right: '1px',
      left: '1px',
      bottom: '1px',
      color: {
        withLightBg: _colors.colors.brandThemeLight100,
        withDarkBg: _colors.colors.brandThemeDark700
      }
    }
  },
  select: {
    background: {
      color: {
        withLightBg: 'transparent',
        withDarkBg: 'transparent'
      }
    },
    border: {
      radius: '0px',
      width: '2px',
      style: 'solid',
      top: '0',
      right: '0',
      left: '0',
      bottom: '2px',
      color: {
        withLightBg: _colors.colors.brandThemeDark900,
        withDarkBg: _colors.colors.white
      },
      hoverColor: {
        withLightBg: _colors.colors.actionPrimary300,
        withDarkBg: _colors.colors.actionPrimary300
      },
      focusColor: {
        withLightBg: _colors.colors.actionPrimary300,
        withDarkBg: _colors.colors.actionPrimary300
      }
    },
    listButtons: {
      hoverColor: _colors.colors.actionPrimary300
    },
    padding: '.7em 1em'
  },
  textField: {
    border: {
      color: {
        withLightBg: _colors.colors.primaryFont,
        withDarkBg: _colors.colors.white
      },
      focusColor: {
        withLightBg: _colors.colors.actionPrimary300,
        withDarkBg: _colors.colors.actionPrimary300
      }
    },
    textColor: {
      withLightBg: _colors.colors.primaryFont,
      withDarkBg: _colors.colors.white
    },
    placeholderColor: {
      withLightBg: _colors.colors.brandThemeDark900,
      withDarkBg: _colors.colors.white
    },
    label: {
      backgroundColor: {
        withLightBg: _colors.colors.white,
        withDarkBg: _colors.colors.brandThemeDark900
      },
      textColor: {
        withLightBg: _colors.colors.primaryFont,
        withDarkBg: _colors.colors.white
      }
    }
  },
  menuItem: {
    textColor: {
      withLightBg: _colors.colors.brandThemeDark900,
      withDarkBg: _colors.colors.white
    },
    hoverTextColor: {
      withLightBg: _colors.colors.actionPrimary300,
      withDarkBg: _colors.colors.actionPrimary300
    },
    selectedTextColor: {
      withLightBg: _colors.colors.actionPrimary300,
      withDarkBg: _colors.colors.actionPrimary300
    },
    backgroundColor: {
      withLightBg: _colors.colors.white,
      withDarkBg: _colors.colors.brandThemeLight100
    },
    hoverBackgroundColor: {
      withLightBg: _colors.colors.white,
      withDarkBg: _colors.colors.brandThemeLight100
    },
    selectedBackgroundColor: {
      withLightBg: _colors.colors.white,
      withDarkBg: _colors.colors.brandThemeLight100
    },
    padding: '1em 1.8em 0.5em 1.8em'
  },
  link: {
    color: {
      default: {
        withLightBg: _colors.colors.actionPrimary300,
        withDarkBg: _colors.colors.actionPrimary300
      },
      primary: {
        withLightBg: _colors.colors.brandThemeDark900,
        withDarkBg: _colors.colors.white
      },
      secondary: {
        withLightBg: _colors.colors.actionPrimary300,
        withDarkBg: _colors.colors.actionPrimary300
      },
      tertiary: {
        withLightBg: _colors.colors.brandThemeDark900,
        withDarkBg: _colors.colors.white
      }
    },
    hoverColor: {
      default: {
        withLightBg: _colors.colors.actionPrimary300,
        withDarkBg: _colors.colors.actionPrimary300
      },
      primary: {
        withLightBg: _colors.colors.actionPrimary300,
        withDarkBg: _colors.colors.actionPrimary300
      },
      secondary: {
        withLightBg: _colors.colors.actionPrimary700,
        withDarkBg: _colors.colors.actionPrimary700
      },
      tertiary: {
        withLightBg: _colors.colors.actionPrimary300,
        withDarkBg: _colors.colors.actionPrimary300
      }
    }
  },
  responseItem: {
    textColor: {
      withLightBg: _colors.colors.primaryFont,
      withDarkBg: _colors.colors.white
    },
    checkboxColor: {
      withLightBg: _colors.colors.actionPrimary300,
      withDarkBg: _colors.colors.white
    },
    borderColor: {
      withLightBg: _colors.colors.brandThemeLight100,
      withDarkBg: _colors.colors.brandThemeDark700
    },
    hoverBackgroundColor: {
      withLightBg: _colors.colors.brandThemeLight300,
      withDarkBg: _colors.colors.brandThemeDark700
    },
    numberingColor: {
      withLightBg: _colors.colors.brandThemeLight300,
      withDarkBg: _colors.colors.brandThemeDark700
    }
  }
};
exports.controls = controls;